"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["volume", "muted", "playbackRate", "onlyWarnForMediaSeekingError", "src", "onDuration", "acceptableTimeshift"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoForDevelopment = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var use_audio_frame_1 = require("../audio/use-audio-frame");

var prefetch_1 = require("../prefetch");

var Sequence_1 = require("../Sequence");

var use_media_in_timeline_1 = require("../use-media-in-timeline");

var use_media_playback_1 = require("../use-media-playback");

var use_media_tag_volume_1 = require("../use-media-tag-volume");

var use_sync_volume_with_media_tag_1 = require("../use-sync-volume-with-media-tag");

var use_video_config_1 = require("../use-video-config");

var volume_position_state_1 = require("../volume-position-state");

var video_fragment_1 = require("./video-fragment");

var VideoForDevelopmentRefForwardingFunction = function VideoForDevelopmentRefForwardingFunction(props, ref) {
  var _a;

  var videoRef = (0, react_1.useRef)(null);
  var volumePropFrame = (0, use_audio_frame_1.useFrameForVolumeProp)();

  var _ref = (0, use_video_config_1.useVideoConfig)(),
      fps = _ref.fps,
      durationInFrames = _ref.durationInFrames;

  var parentSequence = (0, react_1.useContext)(Sequence_1.SequenceContext);

  var volume = props.volume,
      muted = props.muted,
      playbackRate = props.playbackRate,
      onlyWarnForMediaSeekingError = props.onlyWarnForMediaSeekingError,
      src = props.src,
      onDuration = props.onDuration,
      acceptableTimeshift = props.acceptableTimeshift,
      nativeProps = _objectWithoutProperties(props, _excluded);

  var actualVolume = (0, use_media_tag_volume_1.useMediaTagVolume)(videoRef);

  var _ref2 = (0, volume_position_state_1.useMediaVolumeState)(),
      _ref3 = _slicedToArray(_ref2, 1),
      mediaVolume = _ref3[0];

  var _ref4 = (0, volume_position_state_1.useMediaMutedState)(),
      _ref5 = _slicedToArray(_ref4, 1),
      mediaMuted = _ref5[0];

  (0, use_media_in_timeline_1.useMediaInTimeline)({
    mediaRef: videoRef,
    volume: volume,
    mediaVolume: mediaVolume,
    mediaType: 'video',
    src: src
  });
  (0, use_sync_volume_with_media_tag_1.useSyncVolumeWithMediaTag)({
    volumePropFrame: volumePropFrame,
    actualVolume: actualVolume,
    volume: volume,
    mediaVolume: mediaVolume,
    mediaRef: videoRef
  });
  (0, use_media_playback_1.useMediaPlayback)({
    mediaRef: videoRef,
    src: src,
    mediaType: 'video',
    playbackRate: (_a = props.playbackRate) !== null && _a !== void 0 ? _a : 1,
    onlyWarnForMediaSeekingError: onlyWarnForMediaSeekingError,
    acceptableTimeshift: acceptableTimeshift !== null && acceptableTimeshift !== void 0 ? acceptableTimeshift : use_media_playback_1.DEFAULT_ACCEPTABLE_TIMESHIFT
  });
  var actualFrom = parentSequence ? parentSequence.relativeFrom + parentSequence.cumulatedFrom : 0;
  var duration = parentSequence ? Math.min(parentSequence.durationInFrames, durationInFrames) : durationInFrames;
  var actualSrc = (0, video_fragment_1.appendVideoFragment)({
    actualSrc: (0, prefetch_1.usePreload)(src),
    actualFrom: actualFrom,
    duration: duration,
    fps: fps
  });
  (0, react_1.useImperativeHandle)(ref, function () {
    return videoRef.current;
  }, []);
  (0, react_1.useEffect)(function () {
    var current = videoRef.current;

    if (!current) {
      return;
    }

    var errorHandler = function errorHandler() {
      var _a;

      if (current === null || current === void 0 ? void 0 : current.error) {
        console.error('Error occurred in video', current === null || current === void 0 ? void 0 : current.error);
        throw new Error("The browser threw an error while playing the video ".concat(src, ": Code ").concat(current.error.code, " - ").concat((_a = current === null || current === void 0 ? void 0 : current.error) === null || _a === void 0 ? void 0 : _a.message, ". See https://remotion.dev/docs/media-playback-error for help"));
      } else {
        throw new Error('The browser threw an error');
      }
    };

    current.addEventListener('error', errorHandler, {
      once: true
    });
    return function () {
      current.removeEventListener('error', errorHandler);
    };
  }, [src]);
  var currentOnDurationCallback = (0, react_1.useRef)();
  currentOnDurationCallback.current = onDuration;
  (0, react_1.useEffect)(function () {
    var _a;

    var current = videoRef.current;

    if (!current) {
      return;
    }

    if (current.duration) {
      (_a = currentOnDurationCallback.current) === null || _a === void 0 ? void 0 : _a.call(currentOnDurationCallback, src, current.duration);
      return;
    }

    var onLoadedMetadata = function onLoadedMetadata() {
      var _a;

      (_a = currentOnDurationCallback.current) === null || _a === void 0 ? void 0 : _a.call(currentOnDurationCallback, src, current.duration);
    };

    current.addEventListener('loadedmetadata', onLoadedMetadata);
    return function () {
      current.removeEventListener('loadedmetadata', onLoadedMetadata);
    };
  }, [src]);
  return (0, jsx_runtime_1.jsx)("video", _objectSpread({
    ref: videoRef,
    muted: muted || mediaMuted,
    playsInline: true,
    src: actualSrc
  }, nativeProps));
}; // Copy types from forwardRef but not necessary to remove ref


exports.VideoForDevelopment = (0, react_1.forwardRef)(VideoForDevelopmentRefForwardingFunction);